export default {
  data: {
    emojis: [
      {
        id: 0,
        name: "Nauseated Face",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Nauseated%20Face.png",
      },
      {
        id: 1,
        name: "Anxious Face with Sweat",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Anxious%20Face%20with%20Sweat.png",
      },
      {
        id: 2,
        name: "Face with Medical Mask",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Face%20with%20Medical%20Mask.png",
      },
      {
        id: 3,
        name: "Loudly Crying Face",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Loudly%20Crying%20Face.png",
      },
      {
        id: 4,
        name: "Upside-Down Face",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Upside-Down%20Face.png",
      },
      {
        id: 5,
        name: "Woozy Face",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Woozy%20Face.png",
      },
      {
        id: 6,
        name: "Beaming Face with Smiling Eyes",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Beaming%20Face%20with%20Smiling%20Eyes.png",
      },

      {
        id: 7,
        name: "Smiling Face with Sunglasses",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Smiling%20Face%20with%20Sunglasses.png",
      },
      {
        id: 8,
        name: "Smiling Face with Halo",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Smiling%20Face%20with%20Halo.png",
      },
      {
        id: 9,
        name: "Smiling Face with Heart-Eyes",
        source:
          "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Smiling%20Face%20with%20Heart-Eyes.png",
      },
    ],
  },
};
